import FriendItem from "./FriendItem";

const FriendList = ({ isLoading, error, friends, onUnfriendClick }) => {
    
    if (isLoading) return <div className="loading">Loading friends...</div>;
    
    if (error) return <div className="error">Something went wrong!</div>;
    
    if (!friends || friends.length === 0) {
        return <span className="noFriends">You have no friends yet.</span>;
    }

    return (
        <div className="friendListContainer">
            {friends.map((friend) => (
                <FriendItem 
                    key={friend.id} 
                    friend={friend} 
                    onUnfriend={onUnfriendClick} 
                />
            ))}
        </div>
    );
};

export default FriendList;